import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as ecModels from '../../../../models'
import type { Plugin } from '../plugin'

/**
 * TODO
 */
export const cacheGet = store.effects.create(
  <TTypeParams extends ecModels.TypeParams.Constraint>(
    feature: Plugin<TTypeParams>['feature'],
    plugin: Plugin<TTypeParams>,
  ) =>
    plugin.feature.actions.get.success.observe().pipe(
      rxjs.map(action => {
        const { entity } = action.data.response
        if (!entity) {
          // Can only cache entity if we receive it
          return store.effects.SKIP
        }
        return plugin.collection.plugins.cachePlugin.feature.actions.put
          .from(action)
          .create({ entity })
      }),
    ),
)
